import { RulesCreateStateProvider } from 'pages/rules/context/RulesCreateStateContext';
import RuleForm from 'pages/ruleChange/rule/RuleForm';

const RuleCreate = (props: {
  type: string;
  id?: string;
  groupId?: string;
  pageType?: string;
  onDone?: () => void;
}) => (
  <RulesCreateStateProvider>
    <RuleForm {...props} />
  </RulesCreateStateProvider>
);

export default RuleCreate;
